import { listAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/system';

// eslint-disable-next-line @typescript-eslint/unbound-method
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle(() => ({
    item: {
        textStyle: 'body-base',
        color: 'slt-pepper.1000',
    },
}));

const newStyle = {
    container: {
        border: '1px solid',
        borderColor: 'slt-pepper.1000',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        borderTop: 'none',
    },
    item: {
        textStyle: 'body-base',
        color: 'slt-pepper.1000',
        borderRadius: 4,
        paddingX: 4,
        paddingY: 2,
    },
};

export const List = defineMultiStyleConfig({
    baseStyle,
    variants: {
        'new-style': newStyle,
    },
});
